import {getId} from 'apis/model/base'
import React, {useContext, useEffect, useMemo, useState} from 'react'
import {renderCourseClassTimetableWithMilestone} from 'views/Workspace/Course/functions/renderCourseClassTimetableWithMilestone'
import EntityList from '../../../EntityList'
import {bindQueryParam, mapPathParam} from '../../../functions/routerHelper'
import CourseClassContext from '../../CourseClassContext'
import useTranslate from "../../../../../modules/local/useTranslate";
import {SelectWidget} from "../../../custom/ReactSelectComponents";
import _ from "lodash";
import filterOption from "../../../../../helpers/filterOption";
import {PiCalendarFill, PiClockCountdownFill, PiListNumbersBold, PiTreeStructureFill} from "react-icons/pi";
import {Calendar, Modal, Switch, Tabs} from "antd";
import {timetable_getMilestonesByCourseClass_Api} from "../../../../../apis";
import useAsync from "../../../../../modules/asyncCache/useAsync";
import {getResponseItem, NullAsDefault, renderIf, renderIfElse} from "../../../../Shared";
import dayjs from "dayjs";
import {getLocale} from "../../../../../helpers/getLocale";
import {LocalContext} from "../../../../../modules/local/LocalContext";
import {GiPlainCircle} from "react-icons/gi";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import {useToggle} from "react-use";
import {HeaderWithIconLine} from "../../../Templates/items/ListHeader";
import {RiListCheck2} from "react-icons/ri";
import classNames from "classnames";
import {renderCourseClassTimetableDetail} from "../../../../Workspace/Course/functions/renderCourseClassTimetableDetail";
import {GoDotFill} from "react-icons/go";
import getTitle from "../../../../../helpers/getTitle";
import {formatDate} from "../../../../../helpers/datetimeHelpers";
import {ItemInformation} from "../../../../../components/common/ItemInformation";

const TimetableCalendar = ({}) => {
    const t = useTranslate();
    const {isSm} = useContext(LayoutContext)
    const {lang} = useContext(LocalContext)
    const {item} = useContext(CourseClassContext)
    const [current, setCurrent] = useState('0')
    const [subjectId, setSubjectId] = useState()
    const course_class_id = getId(item)

    const apiInfo = timetable_getMilestonesByCourseClass_Api

    const id = getId(item) || item

    const cacheId = mapPathParam(apiInfo.path, {id})

    const {response, isLoading = false} = useAsync({
        apiInfo,
        query: bindQueryParam({id}),
    })

    const isSucceed = Number(_.get(response, 'status')) === 200

    const cache = getResponseItem(response)
    const data = _.get(cache, 'data', [])

    const error = getResponseItem(response, 'error')

    const errorMessage = _.get(response, 'errorMessages.error')

    const error_code = _.get(response, 'errorMessages.error_code')

    const status = {
        title: getResponseItem(response, 'status'),
        description: errorMessage,
    }

    const refreshKey = useMemo(
        () => [course_class_id, subjectId].join(''),
        [course_class_id, subjectId]
    )

    const rawFlattenedData = _.chain(data || [])
        .flatMap(item =>
            _.get(item, 'timetable_details', []).map(detail => {
                return {
                    ...detail,
                    subject: item?.subject,
                    teacher: item?.teacher,
                    notes: item?.notes,
                    phase_title: detail.phase_title,
                    is_holiday: item.is_holiday,
                    year: dayjs(detail.start_time).year(),
                    month: dayjs(detail.start_time).month() + 1,
                    day: dayjs(detail.start_time).date(),
                    ts: dayjs(detail.start_time).valueOf() // Thêm trường ts
                };
            })
        )
        .sortBy('ts') // Sắp xếp theo trường ts
        .value();

    // "Ngày nghỉ" là 1 phase (timetable) riêng với phase buổi học thường, nên
    // 1 ngày có thể có cả 2 bản ghi song song trong data gốc — ưu tiên hiển thị
    // bản ghi nghỉ, ẩn buổi học thường trùng ngày đó.
    const flattenedData = _.chain(rawFlattenedData)
        .groupBy(e => `${e.year}-${e.month}-${e.day}`)
        .flatMap(group => {
            const holidayLessons = group.filter(e => e.is_holiday === 1)
            return holidayLessons.length ? holidayLessons : group
        })
        .sortBy('ts')
        .value()

    const groupedByYearMonthDay = _.chain(flattenedData)
        .groupBy('year')
        .mapValues(yearGroup =>
            _.groupBy(yearGroup, 'month')
        )
        .mapValues(monthGroup =>
            _.mapValues(monthGroup, monthGroupItems =>
                _.groupBy(monthGroupItems, 'day')
            )
        )
        .value();

    const getListData = (year, month, day) => {
        const dataByYear = _.get(groupedByYearMonthDay, year, {})
        const dataByMonth = _.get(dataByYear, month, {})
        const dataByDate = _.get(dataByMonth, day, [])

        return renderIfElse(
            dataByDate?.length,
            [{
                type: 'success',
                // day: `${day}/${month}/${year}`,
                contentData: dataByDate
            }],
            []
        )
    };

    const DateCell = ({data = []}) => {

        const [isToggle, toggle] = useToggle()
        const [contentData, setContentData] = useState([])


        const ModalContent = ({data = [], classes}) => {

            const dateOfWeek = data[0]?.startTime
            const dateSelected = [data[0]?.day, data[0]?.month, data[0]?.year].join('/')

            return (
                <div className="flex flex-col gap-2">
                    <div className="flex flex-col gap-1 mb-2">
                        <span className="text-xs text-color-500 italic">{`${t('selected date')} : `}</span>
                        <div style={{fontFamily: 'Montserrat'}}
                             className="ml-4 font-extrabold text-lg text-primary capitalize tracking-wider">
                            {`${t(formatDate(dateOfWeek,'dddd'))}, ${dateSelected}`}
                        </div>
                    </div>
                    <HeaderWithIconLine
                        renderTitle={() => (
                            <span className="font-bold text-sm text-color-400 uppercase tracking-wider">
                                {t('lesson information')}
                            </span>
                        )}
                    />
                    <div className="ml-0 md:ml-2 flex flex-col gap-4">
                        {data.map((e, i) => {
                            const {start_time, end_time, location_address, subject, teacher, notes, is_holiday} = e ?? {}
                            const starHours = formatDate(start_time,'HH:mm')
                            const endHours = formatDate(end_time,'HH:mm')

                            return renderIfElse(
                                is_holiday === 1,
                                <div className="flex flex-col gap-2">
                                    {renderIf(
                                        notes,
                                        <div className="flex items-start gap-1 text-xs italic">
                                                <span
                                                    className="flex items-center gap-1 text-color-500 whitespace-no-wrap">
                                                    <GoDotFill size={10} className="text-color-500"/>
                                                    {`${t('note')} : `}
                                                </span>
                                            <span className="font-semibold text-color-100 whitespace-pre-line">
                                                    {notes}
                                                </span>
                                        </div>
                                    )}
                                    <div
                                        className="p-3 flex flex-center bg-primary-50 rounded-lg font-semibold text-lg text-primary-600 italic tracking-widest">
                                        {t('holiday')}
                                    </div>
                                </div>,
                                <div key={i} className="flex flex-col gap-1">
                                    <div className="flex items-center gap-2">
                                        <RiListCheck2 size={12} className="text-blue-400"/>
                                        <span className="font-medium text-sm text-blue-600 tracking-wide">
                                            {`${t('lesson')} ${i + 1}`}
                                        </span>
                                    </div>
                                    <div className="ml-2 flex flex-col gap-1">
                                        <ItemInformation primary={true} showIcon={true} label="time"
                                                         value={`${starHours} - ${endHours}`}
                                                         className="text-xs italic"/>
                                        <ItemInformation showIcon={true} label="locations" value={location_address}
                                                         className="text-xs italic"/>
                                        <ItemInformation primary={true} showIcon={true} label="classes" value={classes}
                                                         className="text-xs italic"/>
                                        <ItemInformation showIcon={true}
                                                         label="teacher"
                                                         value={`${teacher?.prefix_title || ''} ${teacher?.fullname}`}
                                                         className="text-xs italic"/>
                                        <ItemInformation showIcon={true} label="subjects" value={`${subject?.title}`}
                                                         className="text-xs italic"/>
                                        {renderIf(
                                            notes,
                                            <div className="flex items-start gap-1 text-xs italic">
                                                <span
                                                    className="flex items-center gap-1 text-color-500 whitespace-no-wrap">
                                                    <GoDotFill size={10} className="text-color-500"/>
                                                    {`${t('note')} : `}
                                                </span>
                                                <span className="font-semibold text-color-100 whitespace-pre-line">
                                                    {notes}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )
        }

        return (
            <React.Fragment>
                {renderIfElse(
                    data?.length,
                    data.map((item, key) => {
                        const {contentData = []} = item ?? {}
                        return (
                            <div
                                key={key}
                                onClick={() => {
                                    setContentData(contentData)
                                    toggle()
                                }}
                                style={{height: isSm ? '100%' : 'calc(100% - 4px)'}} className="flex flex-col">
                                <div
                                    className={classNames("flex flex-row md:flex-col flex-1 gap-1", isSm && 'justify-center')}>
                                    {item?.contentData.slice(0, 2).map((e, i) => {
                                        return renderIfElse(
                                            e?.is_holiday,
                                            <div
                                                key={i} className="space-x-1">
                                                <GiPlainCircle size={7} className="text-primary-300"/>
                                                <span style={{fontSize: 11}}
                                                      className="font-medium text-primary-400 italic tracking-widest">
                                                    {t('holiday')}
                                                </span>
                                            </div>,
                                            <div
                                                key={i}
                                                className={classNames("space-x-1 leading-tight", !isSm && 'max-lines-2')}>
                                                <GiPlainCircle size={7} className="text-blue-400"/>
                                                {renderIf(
                                                    !isSm,
                                                    <span style={{fontSize: 11}}
                                                          className="font-semibold text-blue-600 italic">
                                                    {`${formatDate(e?.start_time, 'HH:mm')} - ${formatDate(e?.end_time, 'HH:mm')}`}
                                                </span>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                                {renderIf(
                                    !isSm,
                                    <div
                                        className="text-right font-medium text-2xs text-color-500 hover:text-color-100 lowercase italic leading-tight cursor-pointer">
                                        {`...${t('view detail')}`}
                                    </div>
                                )}
                            </div>
                        )
                    }),
                    <GiPlainCircle size={7} style={{color: 'transparent'}}/>
                )}
                {isToggle && (
                    <Modal
                        title={
                            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                {t('view detail')}
                            </div>
                        }
                        className="custom-modal"
                        width={540}
                        open={isToggle}
                        onCancel={() => {
                            setContentData([]);
                            toggle()
                        }}
                        footer={null}>
                        <ModalContent data={contentData} classes={getTitle(item)}/>
                        <div className="flex justify-end p-3 mt-6 md:mt-8">
                            <span onClick={toggle}
                                  className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                                {t('close')}
                            </span>
                        </div>
                    </Modal>
                )}
            </React.Fragment>
        )
    }


    return (
        <div className="border border-color-50 rounded-xl overflow-hidden">
            <Calendar
                className="custom-timetable-calendar"
                locale={getLocale(lang)}
                mode="month"
                fullscreen={!isSm}
                cellRender={(value) => {
                    const date = value.date()
                    const month_number = value.month() + 1
                    const month = _.find(data, {value: month_number})
                    const item = _.find(month?.data ?? [], {dom: date})
                    const listData = getListData(value.year(), month_number, value.date());

                    return (
                        <DateCell data={listData}/>
                    )
                }}
            />
        </div>
    )
}

const TimetableTree = ({}) => {
    const t = useTranslate()
    const {item} = useContext(CourseClassContext)
    const [displayAll, setDisplayAll] = useState(false)
    const [subjectId, setSubjectId] = useState()

    const course_class_id = getId(item)

    const refreshKey = useMemo(
        () => [course_class_id, subjectId].join(''),
        [course_class_id, subjectId]
    )

    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center gap-4 px-4 py-3 background-100 rounded-xl">
                <span className="font-medium text-sm text-color-300 italic whitespace-no-wrap">
                    {`${t('subjects')}: `}
                </span>
                <SelectWidget
                    className="flex-1"
                    placeholder={t('choose subject')}
                    showSearch={true}
                    allowClear={true}
                    options={_.get(item, 'class_subjects', []).map(e => {
                        return {label: e?.subject?.title, value: e?.subject?.id}
                    })}
                    filterOption={filterOption}
                    onChange={(value, option) => {
                        setSubjectId(value)
                    }}
                />
                <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="font-medium text-sm text-color-300 italic whitespace-no-wrap">
                        {`${t('display all')} : `}
                    </span>
                    <Switch defaultChecked={displayAll} onChange={(e) => setDisplayAll(e)}/>
                </div>
            </div>
            <EntityList
                key={refreshKey}
                refreshKey={refreshKey}
                RenderEntity={React.Fragment}
                values={{with_milestone: 1, subject_id: subjectId}}
                apiInfo={timetable_getMilestonesByCourseClass_Api}
                query={bindQueryParam({id: course_class_id})}
                renderItem={renderCourseClassTimetableWithMilestone({displayAll})}
            />
        </div>
    )
}

const TimetableTreeDetails = ({}) => {
    const t = useTranslate();
    const {item} = useContext(CourseClassContext)
    const [subjectId, setSubjectId] = useState()
    const [displayAll, setDisplayAll] = useState(false)
    const course_class_id = getId(item)

    const apiInfo = timetable_getMilestonesByCourseClass_Api

    const id = getId(item) || item
    const _values = !!subjectId ? {subject_id: subjectId} : {}
    const {
        response,
        isLoading = false,
        handleAsyncAction = NullAsDefault,
    } = useAsync({
        apiInfo,
        query: bindQueryParam({id}),
        values: {..._values}
    })
    const cache = getResponseItem(response)
    const data = _.get(cache, 'data', [])

    useEffect(() => {
        handleAsyncAction({subject_id: subjectId})
    }, [subjectId])

    const rawFlattenedData = _.flatMap(data || [], item =>
        _.get(item, 'timetable_details', []).map(detail => {
            return {
                ...detail,
                subject: item?.subject,
                teacher: item?.teacher,
                notes: item?.notes,
                phase_title: item.phase_title,
                is_holiday: item.is_holiday,
                sort_key: formatDate(detail?.start_time, "YYYY-MM-DD HH:mm"),
                date_key: formatDate(detail?.start_time, "YYYY-MM-DD"),
            }
        })
    )
    // "Ngày nghỉ" là 1 phase riêng với phase buổi học thường, nên cùng 1 ngày có
    // thể có cả 2 bản ghi song song trong data gốc — ưu tiên bản ghi nghỉ, ẩn
    // buổi học thường trùng ngày đó.
    const flattenedData = _.chain(rawFlattenedData)
        .groupBy('date_key')
        .flatMap(group => {
            const holidayLessons = group.filter(e => e.is_holiday === 1)
            return holidayLessons.length ? holidayLessons : group
        })
        .value()
    const sortedData = _.sortBy(flattenedData, 'sort_key');
    const nearestUpcomingIndex = sortedData.findIndex(e => !dayjs(e.end_time).isBefore(dayjs()))

    return (
        <div className="flex flex-col gap-3">
            <div className="flex items-center gap-4 px-4 py-3 background-100 rounded-xl">
                <span className="font-medium text-sm text-color-300 italic whitespace-no-wrap">
                    {`${t('subjects')}: `}
                </span>
                <SelectWidget
                    className="flex-1"
                    placeholder={t('choose subject')}
                    showSearch={true}
                    allowClear={true}
                    options={_.get(item, 'class_subjects', []).map(e => {
                        return {label: e?.subject?.title, value: e?.subject?.id}
                    })}
                    filterOption={filterOption}
                    onChange={(value, option) => {
                        setSubjectId(value)
                    }}
                />
                <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="font-medium text-sm text-color-300 italic whitespace-no-wrap">
                        {`${t('display all')} : `}
                    </span>
                    <Switch defaultChecked={displayAll} onChange={(e) => setDisplayAll(e)}/>
                </div>
            </div>
            <div className="flex flex-col space-y-3">
                {sortedData.map((e, i) => {
                    const isNearestUpcoming = nearestUpcomingIndex >= 0 && i === nearestUpcomingIndex
                    return (
                        <React.Fragment key={i}>
                            {isNearestUpcoming && (
                                <div className="flex items-center gap-3 py-1">
                                    <div className="h-px flex-1 bg-primary-200"/>
                                    <span className="flex items-center gap-1.5 text-xs font-semibold text-primary bg-primary-50 border border-primary-200 px-3 py-1 rounded-full whitespace-no-wrap">
                                        <PiClockCountdownFill size={13}/>
                                        {t('upcoming')}
                                    </span>
                                    <div className="h-px flex-1 bg-primary-200"/>
                                </div>
                            )}
                            {renderCourseClassTimetableDetail({displayAll})(e)}
                        </React.Fragment>
                    )
                })}
            </div>
        </div>
    )
}

const CourseClassTimetableTab = () => {
    const t = useTranslate()
    const [current, setCurrent] = useState('0')

    return (
        <div className="flex flex-col gap-3">
            <Tabs
                className="custom-tabs-timetables"
                centered={false}
                tabBarGutter={10}
                activeKey={current}
                onChange={(e) => setCurrent(e)}
                items={[
                    {
                        key: "0",
                        label: (
                            <span className="flex items-center gap-2">
          <PiListNumbersBold size={15} />
          <span className="font-medium">{t("overview")}</span>
        </span>
                        ),
                        children: <TimetableTree />,
                    },
                    {
                        key: "1",
                        label: (
                            <div className="flex items-center gap-2">
                                <PiCalendarFill size={15} />
                                <span className="font-medium">{t("monthly calendar")}</span>
                            </div>
                        ),
                        children: <TimetableCalendar />,
                    },
                    {
                        key: "2",
                        label: (
                            <div className="flex items-center gap-2">
                                <PiTreeStructureFill size={15} />
                                <span className="font-medium">{t("detail")}</span>
                            </div>
                        ),
                        children: <TimetableTreeDetails />,
                    },
                ]}
            />

        </div>
    )

}

export default CourseClassTimetableTab
